import Vue from 'vue'

Vue.prototype.$arrayFormat = 'brackets'
Vue.prototype.$alphaREGEX = /^[\p{Letter}\p{Mark}\s.'-]+$/u
// Vue.prototype.$couponREGEX = /^([A-Za-zÀ-ÖØ-öø-ɏ0-9]*)$/u
Vue.prototype.$couponREGEX = /^[\p{Letter}\p{Mark}\p{Number}/-]+$/u
Vue.prototype.$emailREGEX =
    /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(\.(?:[a-zA-Z0-9-])(?:[a-zA-Z0-9-])*)*$/
